



























































import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import { isAddressValid, isEmailValid } from '@/utils/helpers'

@Component({
  props: {
    contactProp: {
      type: Object,
      required: true
    },
    forceShow: {
      type: Boolean,
      default: false
    },
    isAddressValid: {
      type: Function,
      default: isAddressValid
    },
    isEmailValid: {
      type: Function,
      default: isEmailValid
    }
  },
  components: {
    Icon
  }
})
export default class Contact extends Vue {
  showContact: boolean = false
  get contactType () {
    if (!this.contact || !this.contact.typesOfContact) {
      return ''
    }
    return this.contact.typesOfContact.filter((item: any) => !!item).join(', ')
  }

  toggleShowContact () {
    this.showContact = !this.showContact
  }

  beforeMount () {
    this.showContact = this.$props.forceShow
  }

  get contact () {
    return this.$props.contactProp
  }

  get address () {
    const { addressLine1, addressLine2, addressLine3, city, state, zipCode } = this.contact
    return `${addressLine1} ${addressLine2} ${addressLine3} ${city} ${state} ${zipCode}`
  }
}
